<template>
    <div class="toast-box" >
        <p class="toast-value" :class="'toast-type-'+type">
            {{ value }}
        </p> 
    </div>
</template>    
<script>
    export default {
        name: 'Toast',
        props: {
            value: {
                type: String,
                default: ''
            },
            duration: {
                type: Number,
                default: 3000
            },
            background: {
                type: String,
                default: '#000'
            },
            type: {
                type: String,
                default: 'normal'
            }
        }
    }
</script>

<style scoped>
.toast-box  {
    position: fixed;
    width: 100vw;
    height: 100px;
    top: 60vh;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}
    .toast-value {
        max-width: 70vw;
        background: rgb(8, 8, 8);
        padding: 8px 10px;
        border-radius: 8px;
        text-align: center;
        display: inline-block;
        animation: anim 0.5s;
    }
    @keyframes anim { 
            0% {opacity: 0;}
            100%{opacity:1;
        }
    }
    .toast-value.reomve {
        animation: reomve 0.5s;
    }
     @keyframes reomve { 
            0% {opacity: 1;}
            100%{opacity:0;
        }
    }

    .toast-type-normal{
        background: #333;
        color:#fff;
    }
    .toast-type-succ{
        background: #333;
        color:rgb(121, 243, 117);
    }
    .toast-type-err{
        background: #333;
        color:rgb(250, 66, 66);
    }
    .toast-type-fail{
        background: #333;
        color:rgb(248, 219, 55);
    }
</style>